import Section from "../common/Section.tsx";
import { useHomeFeatures } from "./useHomeFeatures.tsx";
import RedeemDialog from "../../actions/redeem/RedeemDialog.tsx";
import { useCallback, useState } from "react";
import styles from "./HomeFeatures.module.scss";
import BaseLinkOrButton from "../../../../common/core-ui/BaseLinkOrButton.tsx";

export default function HomeFeatures({ bookCount }: { bookCount: number }) {
  const [showingRedeemModal, setShowingRedeemModal] = useState(false);
  const featureCards = useHomeFeatures({
    showRedeem: () => setShowingRedeemModal(true),
    bookCount,
  });
  const redeemDialogClose = useCallback(() => setShowingRedeemModal(false), []);

  if (featureCards.cards.length === 0) {
    return null;
  }

  return (
    <>
      <Section
        title={featureCards.title}
        subtitle={featureCards.subtitle}
        gridClassName={styles.grid}
      >
        {featureCards.cards.map((card, index) => {
          const titleId = `HomeFeatures-header-${index}`;
          const descriptionId = `HomeFeatures-description-${index}`;

          return (
            <BaseLinkOrButton
              key={card.title}
              className={styles.card}
              to={card.to}
              onClick={card.onClick}
              aria-labelledby={titleId}
              aria-describedby={descriptionId}
            >
              <div className={styles.iconHolder}>{card.icon}</div>
              <div className={styles.rightContent}>
                <h3 className={styles.title} id={titleId}>
                  {card.title}
                </h3>
                <div id={descriptionId}>{card.description}</div>
              </div>
            </BaseLinkOrButton>
          );
        })}
      </Section>
      {showingRedeemModal && (
        <RedeemDialog onRequestClose={redeemDialogClose} />
      )}
    </>
  );
}
